import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Form,
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { AppDispatch } from "src";
import { useDispatch } from "react-redux";
import {
  deleteFinancing,
  getFinancing,
  updateFinancing,
} from "src/slices/thunks";

const ModalValidation = ({
  selectedFinancing,
  setModal,
  setSuccessDelete,
  setErrorDelete,
  setSuccessUpdate,
  setErrorUpdate,
}: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const validation = useFormik({
    initialValues: {
      name: `${selectedFinancing.name}`,
      descricao: `${selectedFinancing.descricao}`,
      // valor_previsto: `${selectedFinancing.valor_previsto}`,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Por favor, insira o nome"),
      descricao: Yup.string().required("Por favor, insira a descrição"),
      // valor_previsto: Yup.string().required(
      //   "Por favor, insira o valor previsto"
      // ),
    }),

    onSubmit: values => {
      dispatch(updateFinancing({ ...values, id: selectedFinancing.id })).then(
        (response: any) => {
          setModal(false);
          if (
            typeof response.payload === "string" &&
            response.payload.includes("Request failed with")
          ) {
            setErrorUpdate(true);
          } else {
            setSuccessUpdate(true);
          }
        }
      );
    },
  });

  const handleDelete = () => {
    dispatch(deleteFinancing(selectedFinancing.id)).then((response: any) => {
      setModal(false);
      if (
        typeof response.payload === "string" &&
        response.payload.includes("Request failed with")
      ) {
        setErrorDelete(true);
      } else {
        setSuccessDelete(true);
        dispatch(getFinancing());
      }
    });
  };

  return (
    <React.Fragment>
      <Form
        className="needs-validation"
        onSubmit={e => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <Col>
          <FormGroup className="mb-3">
            <Label htmlFor="validationCustom01">Nome</Label>
            <Input
              name="name"
              placeholder="Nome"
              type="text"
              className="form-control"
              id="validationCustom01"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.name || ""}
              invalid={
                validation.touched.name && validation.errors.name ? true : false
              }
            />
            {validation.touched.name && validation.errors.name ? (
              <FormFeedback type="invalid">
                {validation.errors.name}
              </FormFeedback>
            ) : null}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup className="mb-3">
            <Label htmlFor="validationCustom01">Descricão</Label>
            <textarea
              name="descricao"
              placeholder="Descricão"
              className="form-control"
              id="validationCustom01"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.descricao || ""}
              style={{ resize: "none" }}
            />
            {validation.touched.descricao && validation.errors.descricao ? (
              <FormFeedback type="invalid">
                {validation.errors.descricao}
              </FormFeedback>
            ) : null}
          </FormGroup>
        </Col>
        {/* <Col>
          <FormGroup className="mb-3">
            <Label htmlFor="validationCustom03">Valor previsto</Label>
            <Input
              name="valor_previsto"
              placeholder="Valor previsto (MZN)"
              type="text"
              className="form-control"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.valor_previsto || ""}
              invalid={
                validation.touched.valor_previsto &&
                validation.errors.valor_previsto
                  ? true
                  : false
              }
            />

            {validation.touched.valor_previsto &&
            validation.errors.valor_previsto ? (
              <FormFeedback type="invalid">
                {validation.errors.valor_previsto}
              </FormFeedback>
            ) : null}
          </FormGroup>
        </Col> */}

        <div className="d-flex flex-wrap gap-2">
          <Button color="primary" type="submit">
            Submiter
          </Button>
          <Button type="button" color="danger" onClick={handleDelete}>
            Apagar
          </Button>
        </div>
      </Form>
    </React.Fragment>
  );
};

export default ModalValidation;
